var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{class:{ 'window-a': _vm.windowWidth, 'window-b': !_vm.windowWidth },attrs:{"app":""}},[(_vm.ready)?_c('router-view'):_vm._e(),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }